/* eslint-disable no-magic-numbers */

import lodash from 'lodash';

import {EASINGS} from '../../ecs/easingHelper';
import wordCrissCrossInBottomGif from '../../../assets/images/transitions/wordCrissCrossInBottom.gif';

/**
 * The name that signals this preset.
 * @const {string}
 */
export const PRESET_WORD_CRISS_CROSS_OUT_BOTTOM = 'wordCrissCrossOutBottom';

/**
 * The preset details.
 *
 * @type {{
 *   name: string,
 *   flow: string,
 *   details: Object.<string, {
 *     easing: string,
 *     parse: boolean,
 *     values: *|Array.<*>,
 *     time: {start: (string|number), end: (string|number)}
 *   }>,
 *   template: {}
 * }}
 */
export const wordCrissCrossOutBottomPresetDetails = {
  // The name of the preset.
  name: PRESET_WORD_CRISS_CROSS_OUT_BOTTOM,

  // A human friendly name for the preset.
  humanName: 'Word - Criss Cross Out - Bottom',

  // A preview of the transition.
  gif: wordCrissCrossInBottomGif,

  // The element names that this preset can be used for or true for all elements.
  elements: ['text'],

  // The preset direction: in, out, middle. This is used in the UI logic.
  flow: 'out',

  // Each property that will change during the transition.
  details: {
    'word.opacity': {
      easing: EASINGS.easeInExpo,
      time: {
        start: 'end.-2000',
        end: 'end.0'
      },
      values: [
        1,
        0
      ],
      stagger: true,
      staggerDuration: false,
      immediateRender: false
    },
    'word.translateY': {
      easing: EASINGS.easeInExpo,
      time: {
        start: 'end.-2000',
        end: 'end.0'
      },
      values: [
        0,
        100
      ],
      stagger: true,
      staggerDuration: false,
      immediateRender: false
    },
    'word.translateX': [
      {
        easing: EASINGS.easeInExpo,
        time: {
          start: 'end.-2000',
          end: 'end.0'
        },
        values: [
          0,
          -100
        ],
        filters: [
          'even'
        ],
        stagger: true,
        staggerDuration: false,
        immediateRender: false
      },
      {
        easing: EASINGS.easeInExpo,
        time: {
          start: 'end.-2000',
          end: 'end.0'
        },
        values: [
          0,
          100
        ],
        filters: [
          'odd'
        ],
        stagger: true,
        staggerDuration: false,
        immediateRender: false
      }
    ],
  },

  // How this preset can be used in the source (including optional parameters).
  // This will be turned into a JSON string, so no functions can be used.
  template: {
    preset: PRESET_WORD_CRISS_CROSS_OUT_BOTTOM,
    options: {},
  },
};

wordCrissCrossOutBottomPresetDetails.template.options = lodash.cloneDeep(wordCrissCrossOutBottomPresetDetails.details);

// This defines the key in the presets object.
export const presetName = PRESET_WORD_CRISS_CROSS_OUT_BOTTOM;

// This defines the value of the presets object.
export default wordCrissCrossOutBottomPresetDetails;

